import { render, staticRenderFns } from "./MenuBtnEdit.vue?vue&type=template&id=37e40f6c&scoped=true"
import script from "./MenuBtnEdit.vue?vue&type=script&lang=js"
export * from "./MenuBtnEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e40f6c",
  null
  
)

export default component.exports